// Renders something like: 5/10 PAX
export const formatGuestlistPaxOccupancy = (list: server.dto.GuestlistList): string =>
  `${list.paxInUse}/${list.quantity} PAX`;
